import { ApiClient } from "../ApiClient";

/**
 * Submit a review for a filing
 * @param {string} filingId - The filing ID
 * @param {Array} questions - Array of review questions with answers
 * @param {number} overallRating - Optional overall rating from intro modal (0-5)
 * @returns {Promise<Response>} The fetch response
 */
export const submitFilingReview = async (
  filingId,
  questions,
  overallRating = null,
) => {
  if (!filingId) {
    throw new Error("Filing ID is required");
  }

  const payload = { review: questions };

  // Only include overall_rating if provided
  if (overallRating !== null) {
    payload.overall_rating = overallRating;
  }

  // Using ApiClient.post handles CSRF and 401 modal logic automatically
  return ApiClient.post(`/tax/filings/${filingId}/reviews`, payload);
};

/**
 * Check if the current user has already submitted a review for a filing
 * @param {string} filingId - The filing ID
 * @returns {Promise<Response>} The fetch response
 */
export const checkFilingReview = async (filingId) => {
  if (!filingId) {
    throw new Error("Filing ID is required");
  }

  // Construct query parameters
  const params = new URLSearchParams({
    by_user: "True",
  });

  // ApiClient.get handles the base URL and 401 interception
  return ApiClient.get(`/tax/filings/${filingId}/reviews?${params.toString()}`);
};
